import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { Chart } from "react-google-charts";
import { Box, Button, CircularProgress, TextField } from "@mui/material";
import { fetchRuntimeFormDetails } from "../services/FormService";
import { Form } from "react-formio";
import ContentLoader from "../animations/ContentLoader.json";
import Lottie from "lottie-react";
import { FORM_HIDDEN_KEYS, QCR_DISCLAIMER } from "../constants/constants";
import { INITIAL_THEME } from "../theme";
import Colors from "../theme/colors.json";
import ClientLogo from "../assets/svg/Techsophy-logo.svg";
import QCRGraph from "./QCRGraph";

const useStyles = makeStyles((theme) => ({
  qcrPreviewMainConatiner: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    width: "85%",
    pointerEvents: "none",
    fontSize: theme.fontSizes.SMALL,
  },

  logoContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  companyHeading: {
    backgroundColor: "#B92250",
    width: "100%",
  },
  companyHeadingText: {
    display: "flex",
    justifyContent: "center",
    color: "#FFFFFFFF",
    padding: "1%",
    fontSize: "25px",
    fontWeight: 550,
  },
  section: {
    border: "1px solid grey",
  },
  sectionHeading: {
    backgroundColor: "#B92250",
    width: "100%",
  },
  sectionHeadingText: {
    display: "flex",
    // justifyContent: "center",
    color: "#FFFFFFFF",
    padding: "1%",
    fontSize: "20px",
    fontWeight: 600,
  },
  flexKeyValue: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "1%",
    padding: 5,
    width: "100%",
  },
  keyStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    border: "1px solid grey",
    width: "50%",
    fontWeight: 600,
    borderRadius: 5,
  },
  valueStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    border: "1px solid grey",
    width: "50%",
    borderRadius: 5,
  },
  sectionDataFlex: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-around",
  },
  fixedSection: {
    backgroundColor: "#D3D3D3",
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    fontWeight: 400,
    fontSize: "20px",
  },
  proposalKeyStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    border: "1px solid grey",
    width: "100%",
    fontWeight: "bold",
    borderRadius: 5,
  },
  proposalValueStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    border: "1px solid grey",
    width: "100%",
    borderRadius: 5,
  },
  proposalSection: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "2%",
    // width: "100%",
  },
  proposalFlexKeyValue: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "1%",
    padding: 5,
    width: "49%",
  },
  tableHead: {
    backgroundColor: Colors.FORM_HEADING_BG,
    color: theme.palette.secondary.main,
  },
  table: {
    borderCollapse: "collapse",
    width: "100%",
  },
  tableCell: {
    border: "1px solid #dddddd",
    textAlign: "left",
    padding: "3px",
  },
  coveragesLimitIfAnyHeader: {
    // backgroundColor: "#D3D3D3",
    border: "1px solid #dddddd",
  },
  coveragesLimitIfAnyContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // padding: "0.5%",
  },
  coverageSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    width: "150px",
  },
  limitIfAnySection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    width: "150px",
  },
  chartCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "auto",
    width: "100%",
    overflow: "hidden",
    border: "1px solid #dddddd",
    padding: "2%",
  },
  chartHeading: {
    // backgroundColor: theme.palette.primary.main,
    width: "fit-content",
  },
  chartHeadingText: {
    fontWeight: 600,
    color: theme.palette.secondary.main,
    padding: 3,
  },
  loader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center !important",
    alignItems: "center !important",
  },
  commentsInsightsSection: {
    border: "1px solid #dddddd",
    marginTop: "1%",
  },
  commentsInsightsHeading: {
    backgroundColor: Colors.FORM_HEADING_BG,
    color: theme.palette.secondary.main,
    fontWeight: 600,
    padding: "0.5%",
    borderBottom: "1px solid #dddddd",
  },
  commentsInsightsContent: {
    padding: "2%",
  },
  disclaimerSection: {
    border: "1px solid #dddddd",
    marginTop: "1%",
  },
  disclaimerHeading: {
    backgroundColor: Colors.FORM_HEADING_BG,
    color: theme.palette.secondary.main,
    fontWeight: 600,
    padding: "0.5%",
    borderBottom: "1px solid #dddddd",
  },
  disclaimerContent: {
    padding: "2%",
  },
  qcrHeadingText: {
    // backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
    fontSize: "2vw",
    fontWeight: 700,
    display: "flex",
    justifyContent: "center",
  },
  formStylesOveride: {
    "& .choices__list--dropdown, & .choices__list": {
      height: "0px",
    },
    "& .remarks-section-formio": {
      display: "none",
    },
  },
  tableCellHeading: {
    border: "1px solid #dddddd",
    textAlign: "left",
    padding: "3px",
    fontWeight: 600,
  },
  pdfPreviewContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  commentsInsightsField: {
    fontSize: theme.fontSizes.SMALL,
  },
}));

const animationStyle = {
  height: "50vh",
};

const QCRPreview = (props) => {
  const { qcrContentRef } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const { proposalDataRedux } = useSelector((state: any) => ({
    proposalDataRedux: state.proposalData,
  }));

  const [proposalForm, setProposalForm] = useState<any>({});
  const [rfqData, setRfqData] = useState<any>({});

  const [underwriterInfo, setUnderwriterInfo] = useState<any>({});
  const [chartData, setChartData] = useState<any>([]);

  // Get today's date
  const today = new Date();

  // Extract day, month, and year components
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = today.getFullYear();

  function convertToTitleFormat(text) {
    if (!text) {
      return "";
    }

    return text.replace(/([A-Z])/g, " $1").replace(/^./, function (str) {
      return str.toUpperCase();
    });
  }

  function toCamelCase(inputString) {
    // Check if inputString is empty, null, or undefined
    if (!inputString || typeof inputString !== "string") {
      return ""; // Or handle this case based on your requirements
    }

    const words = inputString.split(/\s+/);

    const camelCaseWords = words.map((word, index) => {
      if (index === 0) {
        return word.toLowerCase();
      } else {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      }
    });

    return camelCaseWords.join("");
  }

  const getUnderwriterInfo = (underwriterData) => {
    // Your provided data
    const data = JSON.parse(JSON.stringify(underwriterData));

    // Sort premiumData based on premiumAfterTax

    // Find and remove the object with insuranceProvider: "Original"
    // const originalIndex = data?.premiumData?.findIndex(
    //   (item) => item?.insuranceProvider === "Original"
    // );
    // if (originalIndex !== -1) {
    //   data?.premiumData?.splice(originalIndex, 1);
    // }

    const originalData = data?.premiumData?.filter(
      (item) => item?.insuranceProvider === "Original"
    );

    const nonOriginalData = data?.premiumData?.filter(
      (item) => item?.insuranceProvider !== "Original"
    );
    nonOriginalData.sort((a, b) => a.premiumAfterTax - b.premiumAfterTax);

    if (data?.conditions?.isCurrentPolicyInPlace) {
      data.premiumData = [...originalData, ...nonOriginalData];
    } else {
      data.premiumData = [...nonOriginalData];
    }

    setUnderwriterInfo(data || {});

    const builtChartData = data?.premiumData?.map((item) => {
      return [
        item?.insuranceProvider,
        item?.premiumAfterTax,
        `color: ${INITIAL_THEME.palette.primary.main}`,
      ];
    });

    setChartData([...(builtChartData || [])]);
  };

  const getProposalForm = async (formId) => {
    const response: any = await fetchRuntimeFormDetails(formId);
    if (response.success) {
      const form = replaceDisableAddingRemovingRows(
        response?.data?.components || {}
      );
      setProposalForm(form);
    } else {
      setProposalForm({ display: "form", components: [] });
    }
  };

  function replaceDisableAddingRemovingRows(data) {
    if (Array.isArray(data)) {
      data.forEach(replaceDisableAddingRemovingRows);
    } else if (typeof data === "object" && data !== null) {
      Object.keys(data).forEach((key) => {
        if (key === FORM_HIDDEN_KEYS.disableAddingRemovingRows && !data[key]) {
          data[key] = true;
        }
        const isLabelOrTitle = key === "label" || key === "title";
        if (
          isLabelOrTitle &&
          data[key] === FORM_HIDDEN_KEYS.relationShipManager
        ) {
          data["hidden"] = true;
        } else if (
          isLabelOrTitle &&
          data[key] === FORM_HIDDEN_KEYS.serviceManager
        ) {
          data["hidden"] = true;
        } else if (
          isLabelOrTitle &&
          data[key] === FORM_HIDDEN_KEYS.enclosures
        ) {
          data["hidden"] = true;
        } else if (isLabelOrTitle && data[key] === FORM_HIDDEN_KEYS.remarks) {
          data["hidden"] = true;
        } else if (typeof data[key] === "object" && data[key] !== null) {
          replaceDisableAddingRemovingRows(data[key]);
        }
      });
    }
    return data;
  }

  useEffect(() => {
    getProposalForm(proposalDataRedux?.formId);
    setRfqData(proposalDataRedux?.formData || {});
    getUnderwriterInfo(proposalDataRedux?.formData?.underwriterDetails || {});
  }, []);

  return (
    <div className={classes.pdfPreviewContainer}>
      {Object.keys(proposalForm)?.length === 0 ||
      Object.keys(rfqData)?.length === 0 ||
      Object.keys(underwriterInfo)?.length === 0 ? (
        <Box className={classes.loader}>
          <Lottie
            animationData={ContentLoader}
            loop={true}
            style={animationStyle}
          />
          {/* <CircularProgress size={80} />
          ...Please Wait */}
        </Box>
      ) : null}
      {!(Object.keys(proposalForm)?.length === 0) &&
      !(Object.keys(rfqData)?.length === 0) &&
      !(Object.keys(underwriterInfo)?.length === 0) ? (
        <div className={classes.qcrPreviewMainConatiner}>
          <div ref={qcrContentRef} className={classes.formStylesOveride}>
            <div className={classes.qcrHeadingText}>
              Quote Comparison Report
            </div>
            <div className="techshophy-logo-container-preview">
              <img
                src={sessionStorage.getItem("logoURL") || ClientLogo}
                alt="client-logo"
              />
            </div>
            <Form
              form={proposalForm}
              submission={{ data: { ...rfqData } }}
              options={{
                readOnly: true,
                flatten: true,
                renderMode: "html",
              }}
            />
            {/* <div className="html2pdf__page-break"></div> */}
            {chartData?.length > 1 ? (
              <div className={classes.chartCard}>
                <div className={classes.chartHeading}>
                  <div className={classes.chartHeadingText}>
                    Premium Quote Comparision
                  </div>
                </div>

                <QCRGraph data={chartData.slice(1)} />

                {/* <Chart
                  chartType="ColumnChart"
                  data={chartData}
                  width={"95%"}
                  height={"100%"}
                  options={{
                    colors: [INITIAL_THEME.palette.primary.main],
                  }}
                /> */}
              </div>
            ) : null}
            {/* <div className="html2pdf__page-break"></div> */}
            <div>
              <table className={classes.table}>
                <thead className={classes.tableHead}>
                  <tr>
                    <th className={classes.tableCellHeading}>
                      Insurance Company
                    </th>
                    {underwriterInfo?.premiumData?.map((item, index) => {
                      return (
                        <>
                          {item?.insuranceProvider === "Original" ? (
                            <th className={classes.tableCellHeading}>
                              Expiring Terms
                            </th>
                          ) : (
                            <th className={classes.tableCellHeading}>
                              {item?.insuranceProvider}
                            </th>
                          )}
                        </>
                      );
                    })}
                  </tr>
                  <tr>
                    <th className={classes.tableCellHeading}>
                      Premium Position
                    </th>
                    {underwriterInfo?.premiumData?.map((item, index) => {
                      return (
                        <>
                          {item?.insuranceProvider === "Original" ? (
                            <th className={classes.tableCellHeading}></th>
                          ) : (
                            <th className={classes.tableCellHeading}>
                              {underwriterInfo?.conditions
                                ?.isCurrentPolicyInPlace
                                ? `L${index}`
                                : `L${index + 1}`}
                            </th>
                          )}
                        </>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={classes.tableCell}>Premium excl. Tax</td>
                    {underwriterInfo?.premiumData?.map((item, index) => {
                      return (
                        <td className={classes.tableCell}>
                          ₹ {item?.premiumBeforeTax}
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    <td className={classes.tableCell}>
                      GST @ {underwriterInfo?.taxes?.gst}%
                    </td>
                    {underwriterInfo?.premiumData?.map((item, index) => {
                      return (
                        <td className={classes.tableCell}>₹ {item?.GST18}</td>
                      );
                    })}
                  </tr>

                  <tr>
                    <td className={classes.tableCell}>Stamp Duty</td>
                    {underwriterInfo?.premiumData?.map((item, index) => {
                      return (
                        <td className={classes.tableCell}>
                          ₹ {item?.stampDuty}
                        </td>
                      );
                    })}
                  </tr>

                  <tr>
                    <td className={classes.tableCell}>Premium incl. GST</td>
                    {underwriterInfo?.premiumData?.map((item, index) => {
                      return (
                        <td className={classes.tableCell}>
                          ₹ {item?.premiumAfterTax}
                        </td>
                      );
                    })}
                  </tr>

                  <tr className={classes.tableHead}>
                    <th
                      className={classes.tableCell}
                      colSpan={underwriterInfo?.premiumData?.length + 1}
                    >
                      Terms
                    </th>
                  </tr>
                  <tr className={classes.coveragesLimitIfAnyHeader}>
                    <th>
                      <div className={classes.coveragesLimitIfAnyContainer}>
                        <div className={classes.coverageSection}>COVERAGE</div>
                        {/* {underwriterInfo?.conditions
                          ?.isCurrentPolicyInPlace && (
                          <div className={classes.limitIfAnySection}>
                            Expiring Terms Limit If any
                          </div>
                        )} */}
                        <div className={classes.limitIfAnySection}>
                          Proposed Terms Limit If any
                        </div>
                      </div>
                    </th>
                    {underwriterInfo?.premiumData?.map((item, index) => {
                      return <th className={classes.tableCell}>{""}</th>;
                    })}
                  </tr>
                  {underwriterInfo?.underwriterData?.map((item, index) => {
                    return (
                      <tr>
                        <td className={classes.tableCell}>
                          <div className={classes.coveragesLimitIfAnyContainer}>
                            <div className={classes.coverageSection}>
                              {item?.coverage}
                            </div>
                            {/* {underwriterInfo?.conditions
                              ?.isCurrentPolicyInPlace && (
                              <div className={classes.limitIfAnySection}>
                                {item?.expiringTermsLimitIfAny}
                              </div>
                            )} */}
                            <div className={classes.limitIfAnySection}>
                              {item?.proposedTermsLimitIfAny}
                            </div>
                          </div>
                        </td>
                        {underwriterInfo?.premiumData?.map((row, index) => {
                          const insuranceProvider =
                            row?.insuranceProvider === "Original"
                              ? "expiringTerms"
                              : toCamelCase(row?.insuranceProvider);

                          return (
                            <td className={classes.tableCell}>
                              {`${
                                item[insuranceProvider + "YesNo"]
                                  ? item[insuranceProvider + "YesNo"]
                                  : ""
                              }${
                                item[insuranceProvider + "YesNo"] &&
                                item[insuranceProvider + "LimitIfAny"]
                                  ? ","
                                  : ""
                              } ${
                                item[insuranceProvider + "LimitIfAny"]
                                  ? item[insuranceProvider + "LimitIfAny"]
                                  : ""
                              }`}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className={classes.commentsInsightsSection}>
              <div className={classes.commentsInsightsHeading}>
                Comments & Key Insights
              </div>
              <div className={classes.commentsInsightsContent}>
                <TextField
                  multiline
                  id="Comments-KeyInsights"
                  value={underwriterInfo?.commentsKeyInsights}
                  fullWidth
                  InputProps={{
                    className: classes.commentsInsightsField,
                  }}
                />
              </div>
            </div>
            <div className={classes.disclaimerSection}>
              <div className={classes.disclaimerHeading}>Disclaimer</div>
              <div className={classes.disclaimerContent}>{QCR_DISCLAIMER}</div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default QCRPreview;
